module.exports = __webpack_public_path__ + "static/media/pending-approval.81ef2511.svg";